import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

// components
import Tile from './Tile.js'

class TileButton extends React.Component {
	static propTypes = {
		active: PropTypes.bool,
		contentClass: PropTypes.string,
		id: PropTypes.string.isRequired,
		isMoney: PropTypes.bool.isRequired,
		label: PropTypes.string.isRequired,
		onClick: PropTypes.func,
		text: PropTypes.string.isRequired,
	}

	static defaultProps = {
		active: false,
		contentClass: '',
		isMoney: false,
		label: '',
		onClick: () => {
		},
		text: '',
	}

	handleOnClick = () => {
		this.props.onClick(!this.props.active)
	}

	render() {
		return (
			<div className='row my-3'>
				<div className='col-12'>
					<div className='row mb-3'>
						<div className='col-4 col-sm-2 col-lg-1'>
							<Tile
								active={this.props.active}
								id={this.props.id}
								isMoney={this.props.isMoney}
								label={this.props.label}
								onClick={this.handleOnClick}
								value={!this.props.active}
							/>
						</div>
						<div className='col-7 py-3'>
							{this.props.text}
						</div>
					</div>
				</div>
				<div className={classNames('col-12', { 'd-none': !this.props.active })}>
					{this.props.children}
				</div>
			</div>
		)
	}
}

export default TileButton
